import mitt from "mitt"

const modalEventBus = mitt()
export default modalEventBus
